/* tslint:disable */

declare var Object: any;
export interface TtamondutyallowitemInterface {
  "itemCode": string;
  "categoryCode"?: string;
  "currencyCode"?: string;
  "type"?: string;
  "itemNameEn"?: string;
  "itemNameId"?: string;
  "itemNameMy"?: string;
  "itemNameTh"?: string;
  "formula"?: string;
  "itemOrder"?: number;
  "companyId": number;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy": string;
  "modifiedDate": Date;
}

export class Ttamondutyallowitem implements TtamondutyallowitemInterface {
  "itemCode": string;
  "categoryCode": string;
  "currencyCode": string;
  "type": string;
  "itemNameEn": string;
  "itemNameId": string;
  "itemNameMy": string;
  "itemNameTh": string;
  "formula": string;
  "itemOrder": number;
  "companyId": number;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy": string;
  "modifiedDate": Date;
  constructor(data?: TtamondutyallowitemInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Ttamondutyallowitem`.
   */
  public static getModelName() {
    return "Ttamondutyallowitem";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Ttamondutyallowitem for dynamic purposes.
  **/
  public static factory(data: TtamondutyallowitemInterface): Ttamondutyallowitem{
    return new Ttamondutyallowitem(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Ttamondutyallowitem',
      plural: 'Ttamondutyallowitems',
      path: 'Ttamondutyallowitems',
      properties: {
        "itemCode": {
          name: 'itemCode',
          type: 'string'
        },
        "categoryCode": {
          name: 'categoryCode',
          type: 'string'
        },
        "currencyCode": {
          name: 'currencyCode',
          type: 'string'
        },
        "type": {
          name: 'type',
          type: 'string'
        },
        "itemNameEn": {
          name: 'itemNameEn',
          type: 'string'
        },
        "itemNameId": {
          name: 'itemNameId',
          type: 'string'
        },
        "itemNameMy": {
          name: 'itemNameMy',
          type: 'string'
        },
        "itemNameTh": {
          name: 'itemNameTh',
          type: 'string'
        },
        "formula": {
          name: 'formula',
          type: 'string'
        },
        "itemOrder": {
          name: 'itemOrder',
          type: 'number'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "createdDate": {
          name: 'createdDate',
          type: 'Date'
        },
        "modifiedBy": {
          name: 'modifiedBy',
          type: 'string'
        },
        "modifiedDate": {
          name: 'modifiedDate',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Ttamondutyallowitem.ts